<template>
	<div class="timeline">
		<!-- <div class="timeline-action">
            <button class="timeline-action__btn">
                <Icon name="mdi:plus" size="24" />
            </button>
        </div> -->
		<div class="timeline__content">
			<div class="timeline__list">
				<div v-for="({ id, title, text }, i) in data" :id="id" :key="i" class="timeline__item">
					<div class="timeline__tree">
						<div class="timeline__tree-line"></div>
						<button
							type="button"
							class="timeline__item-btn"
							:aria-label="`Scroll to ${title}`"
							@click="scrollToTimelineItem(id)">
							<Icon name="mdi:plus" size="16" />
						</button>
					</div>
					<article class="timeline__article">
						<UIHeading level="5" class="timeline__article-title">
							{{ title }}
						</UIHeading>
						<p class="timeline__article-text">
							{{ text }}
						</p>
					</article>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	defineProps<{
		data: { id: string; title: string; text: string }[]
	}>()

	const { $gsap: gsap } = useNuxtApp()

	function scrollToTimelineItem(id: string) {
		if (!import.meta.client) return
		const target = document.getElementById(id)
		if (!target) return
		target.scrollIntoView({ behavior: 'smooth', block: 'start' })
		window.history.replaceState(null, '', `#${id}`)
	}

	function timelineAnimation() {
		const timelineItems = gsap.utils.toArray('.timeline__item')

		timelineItems.forEach((item) => {
			const element = item as Element
			// ScrollTrigger.create({
			// 	trigger: element,
			// 	start: 'top-=150 top',
			// 	end: 'bottom top',
			// 	toggleClass: { targets: element, className: 'active' },
			// })
			gsap.to(element, {
				scrollTrigger: {
					trigger: element,
					start: 'top center',
					// start: 'top-=150 top',
					end: 'bottom top',
					// toggleClass: { targets: element, className: 'active' },
					onEnter: () => element.classList.add('active'),
					onEnterBack: () => element.classList.add('active'),
					onLeaveBack: () => element.classList.remove('active'),
					scrub: true,
				},
				borderImageSource: `linear-gradient(-180deg, #ffc800 200%, #e3e4e5 0%)`,
			})
		})
	}

	onMounted(() => {
		setTimeout(() => {
			timelineAnimation()
		}, 200)
	})
</script>

<style scoped lang="scss">
	.timeline {
		// padding-right: 100px;
		@media (width <= 991.98px) {
			grid-column: span 2;
		}
		&__list {
			display: flex;
			flex-direction: column;

			@media (width <= 991.98px) {
				// max-width: 50%;
				// margin: 0 auto;
				padding: 0 24px;
			}
		}
		&__item {
			display: flex;
			gap: 120px;
			text-align: left;

			scroll-margin-top: 50px;
			border: 2px solid transparent;

			@media (width <= 991.98px) {
				gap: 20px;
			}
			&:not(:last-child) {
				padding-bottom: 150px;
				border-width: 2px;
				border-top: 0;
				border-right: 0;
				border-bottom: 0;
				border-image-source: linear-gradient(-180deg, #ffc800 0%, #e3e4e5 0%);

				// border-left-width: 1px;
				// border-left-style: solid;
				// border-image: linear-gradient(
				// 	to bottom,
				// 	rgba(0, 0, 0, 0.1),
				// 	rgba(0, 0, 0, 0.1) 10%,
				// 	transparent 10%,
				// 	transparent
				// );
				border-image-slice: 1;

				@media (width <= 767.98px) {
					padding-bottom: 50px;
				}
			}
			&:last-child {
				.timeline__tree-line {
					display: none;
				}
			}
			&.active {
				.timeline__item-btn {
					background-color: var(--primary);
				}
				.timeline__article {
					opacity: 1;
				}
			}
			&-btn {
				position: relative;
				left: -15px;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 6px;
				color: var(--white);
				background-color: var(--gray400);
				border: none;
				border-radius: 50%;
				cursor: pointer;
				transition:
					background-color 0.3s,
					transform 0.3s;
				&:hover {
					transform: scale(1.2);
				}
			}
		}
		&__tree {
			position: relative;
			height: inherit;

			// &-line {
			// 	position: absolute;
			// 	top: 0;
			// 	left: 50%;
			// 	transform: translateX(-50%);
			// 	width: 1px;
			// 	height: 100%;
			// 	background-color: var(--gray400);
			// }
		}
		&__article {
			max-width: 60%;
			opacity: 0;
			transition: 0.4s opacity;

			@media (width <= 991.98px) {
				max-width: 100%;
			}
			&-title {
				text-transform: uppercase;
			}
			&-text {
				margin-top: 8px;
			}
		}
	}
</style>
